import { Component, Input } from '@angular/core';
import Loading from 'src/app/_global/loading';
import { LoadingService } from 'src/app/_services/loading.service';

@Component({
  selector: 'loading',
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
})
export class LoadingComponent {

  @Input() cover = true;
  @Input() loader: Loading = this.loadingService.getMainLoader();
  // A bound spinner reflects its own request; it must not overwrite shared loaders.
  @Input() loading: boolean | null | undefined;


  constructor(public loadingService: LoadingService) { }
}
